import { SelectedCompanyMethod } from "../..";

export class CustomerPartnerURLs {
  constructor(private readonly customerHome: SelectedCompanyMethod) {}
  home() {
    return `${this.customerHome()}/partners`;
  }
}
